import "./AutomationSource.css";
import img from "../autoassets/source.png";

export default function AutomationSource() {
  const cardsData = [
    {
      title: "Automated Deployment Pipelines",
      description:
        "We design end-to-end deployment pipelines that automatically deliver code from development to staging and production environments, reducing manual intervention and errors.",
    },
    {
      title: "CI/CD Integration",   
      description:
        "Seamless integration with CI/CD tools like Jenkins, GitHub Actions, and GitLab to enable faster and more reliable releases.",
    },
    {
      title: "Environment Management",
      description:
        "Consistent configuration across development, staging, and production environments to avoid deployment mismatches.",
    },
    {
      title: "Rollback & Recovery",
      description:
        "Automated rollback mechanisms to quickly recover from failed deployments with minimal downtime.",
    },
    {
      title: "Monitoring & Alerts",
      description:
        "Real-time monitoring and alerting to track deployment health and detect issues early.",
    },
    {
      title: "Monitoring & Alerts",
      description:
        "Real-time monitoring and alerting to track deployment health and detect issues early.",
    },
  ];

  return (
    <div id="automation-source" className="outsourcemainclass">
      <h2 className="heading">Our IT Outsourcing Services</h2>
      <p className="subheading">
        Empowering your business with skilled talent, flexible models, and
        reliable technology solutions.
      </p>
      <div className="source-container">
        <div className="left">
          <img src={img} alt="error" />
        </div>

        <div className="right">
          <div className="cards">
            {cardsData.map((card, index) => (
              <div className="card" key={index}>
                <div className="content">
                  <h3>{card.title}</h3>
                  <p>{card.description}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}
